
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

// Api
import { login } from 'api/auth'

// Hooks
import useMounted from 'use/mounted'

// Components
import IconPin from 'ui/Icons/IconPin'
import Text from 'ui/Text'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Modal from 'ui/Modal'
import Button from 'ui/Button'
import Line from 'ui/Line'
import Space from 'ui/Space'
import Loading from 'ui/Loading'

export const PopupResetPassword = ({
  title,
  icon,
  description,
  label,
  emailReceiver,
  onConfirm,
  ...props
}) => {
  // State
  const [visible, setVisibleState] = useState(true)
  const [preloading, setPreLoading] = useState(false)
  const [resending, setResending] = useState(false)
  const [loading, setLoadingState] = useState(false)
  const [countDown, setCountDown] = useState(60)

  // Form hook
  const isMounted = useMounted()
  const setVisible = useCallback(
    (state) => {
      if (isMounted.current) {
        setVisibleState(state)
      }
    },
    [isMounted]
  )
  const setLoading = useCallback(
    (state) => {
      if (isMounted.current) {
        setLoadingState(state)
      }
    },
    [isMounted]
  )
  const input = {email:emailReceiver,password:"Yondu@123!",provider:null,socialToken:null}
  const starter = async() => {}
  const startCountdown = () => {
    let interval = null
    setPreLoading(true)

    starter()
      .then(() => {
        interval = setInterval(() => {
          setCountDown((pre) => {
            if (pre - 1 === 0) {
              clearInterval(interval)
            }
            return pre - 1
          })
        }, 1000)
      })
      .catch(() => {
        //
      })
      .finally(() => {
        setPreLoading(false)
      })

    return () => {
      clearInterval(interval)
    }
  }
  useEffect(() => {
    startCountdown()
  }, [])

const onConfirmClick = async () => {
    setLoading(true)
    if (onConfirm) {
      await onConfirm({
        setVisible,
        setLoading,
      })
      return
    }
    setVisible(false)
    setLoading(false)
  }

const onResendClick = () => {
    setResending(true)
    setCountDown(60)

    login(input,emailReceiver)
    .then(() => {
        const interval = setInterval(() => {
          setCountDown((pre) => {
            if (pre - 1 === 0) {
              clearInterval(interval)
            }
            return pre - 1
          })
        }, 1000)
      })
      .catch(() => startCountdown())
      .finally(() => {
        if (isMounted.current) {
          setResending(false)
        }
      })
  }

  return (
    <Modal show={visible} style={{ textAlign: 'center' }} {...props}>
      <Loading spinning={preloading}>
        <div style={{ textAlign: 'center' }}>{icon}</div>
        <Text size={20} bold paddingBottom={5} color="#000000">
          {title}
        </Text>
        <Text size={14} color="#000000" paddingBottom={15}>
        {description}
        </Text>
        

        <Text size={14} color="#000000" paddingBottom={15}>
          {label}
        </Text>
        <Line />

        <Space style={{ paddingBottom: 30, justifyContent: 'center' }}>
          <Text size={14} color="#000000">
            Didn't receive the email?
          </Text>
          <Space>
            <Button
              variant="link"
              disabled={countDown > 0}
              onClick={onResendClick}
              loading={resending}
            >
              Resend
            </Button>
          </Space>
          {countDown > 0 && (
            <Text size={14} color="#606266">
              (00:{countDown >= 10 ? countDown : '0' + countDown})
            </Text>
          )}
        </Space>

        <Row>
          <Col>
            <Button block onClick={onConfirmClick} loading={loading}>
              Okay, got it
            </Button>
          </Col>
        </Row>
      </Loading>
    </Modal>
  )
}

PopupResetPassword.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.string,
  emailReceiver: PropTypes.string,
  icon: PropTypes.node,
  onConfirm: PropTypes.func,

}

PopupResetPassword.defaultProps = {
  title: 'Please reset your password',
  description: 'Paytrack has migrated its User Management System. To keep your account secure, you need to reset your password.',
  label: 'We sent a reset password link to your email.',
  icon: <IconPin />,
  emailReceiver:null,
  onConfirm: null,
}

export default PopupResetPassword
